const toggleSlide = itemElement => {
  const actionElement = itemElement.find(".js-faq-accordion-item");
  const bodyElement = itemElement.find(".faq-accordion__body");
  const newAttrValue =
    actionElement.attr("aria-expanded") === "true" ? "false" : "true";
  const bodyAttrValue =
    bodyElement.attr("aria-hidden") === "true" ? "false" : "true";

  actionElement.attr("aria-expanded", newAttrValue);
  bodyElement.attr("aria-hidden", bodyAttrValue).slideToggle(200);
  itemElement.toggleClass("is-active");

  return false;
};

const initFaqAccordion = () => {
  $(".js-faq-accordion-item")
    .off()
    .on("click", function() {
      toggleSlide($(this).closest(".faq-accordion__item"));
    })
    .on("keydown", function(event) {
      if (event.which === 32 || event.which === 13) {
        event.preventDefault();
        toggleSlide($(this).closest(".faq-accordion__item"));
      }
    });
};

export default initFaqAccordion;
